import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2bada4e6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "editor__cropper-container" }
const _hoisted_3 = { class: "upload-select-image-wrapper" }
const _hoisted_4 = { class: "upload-image-container" }
const _hoisted_5 = { class: "upload-image-container__button" }
const _hoisted_6 = { class: "upload-image-container__button__text" }
const _hoisted_7 = { class: "upload-image-container__tips" }
const _hoisted_8 = { class: "background-image-type-container__title" }
const _hoisted_9 = { class: "background-image-type-container__list" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VueCropper = _resolveComponent("VueCropper")!
  const _component_Icon = _resolveComponent("Icon")!
  const _component_NUpload = _resolveComponent("NUpload")!
  const _component_NScrollbar = _resolveComponent("NScrollbar")!
  const _component_NCard = _resolveComponent("NCard")!
  const _component_NModal = _resolveComponent("NModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.editor.showEditor)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "editor__cropper-wrapper",
          onContextmenu: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop","prevent"]))
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_VueCropper, {
              containerStyle: { height: '100%', width: '100%' },
              imgStyle: { height: '100%', width: '100%' },
              ref: 
(el) => {
              ;(_ctx.editor.cropperRef as unknown as any) = el
            }
          ,
              src: _ctx.editor.cropperSrc,
              dragMode: "move",
              viewMode: 3,
              autoCropArea: 1,
              aspectRatio: NaN,
              restore: false,
              guides: false,
              center: false,
              highlight: false,
              cropBoxMovable: false,
              cropBoxResizable: false,
              toggleDragModeOnDblclick: false,
              modal: false
            }, null, 8, ["src"])
          ])
        ], 32))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["background-editor__slot", {
        'background-editor__slot-disabled': _ctx.editor.showEditor,
        'background-editor__slot-mask': _ctx.showBackgroundMaskBlur || false
      }])
    }, [
      _renderSlot(_ctx.$slots, "default", {
        showEditor: _ctx.editor.showEditor,
        editor: _ctx.editor,
        handleHeadContextMenu: _ctx.handleContextMenu
      }, undefined, true)
    ], 2),
    _createVNode(_component_NModal, {
      show: _ctx.editor.showSelector,
      "onUpdate:show": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.editor.showSelector) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_NCard, {
          style: {"width":"640px","height":"534px"},
          title: _ctx.t(`${_ctx.tBasePrefix}.title`),
          bordered: false,
          size: "huge",
          role: "dialog",
          "aria-modal": "true"
        }, {
          "header-extra": _withCtx(() => [
            _createVNode(_component_Icon, {
              name: "closeBackgroundEditor",
              onClick: _ctx.closeSelector
            }, null, 8, ["onClick"])
          ]),
          default: _withCtx(() => [
            _createVNode(_component_NScrollbar, { style: {"height":"calc(534px - 76px)"} }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, [
                    _createVNode(_component_NUpload, {
                      accept: ".png,.jpg,.jpeg,.svg,.bmp",
                      ref: 
              (el) => {
                ;(_ctx.editor.uploadRef as unknown as any) = el
              }
            ,
                      "show-file-list": false,
                      "default-upload": false,
                      onChange: _ctx.editor.handleChange
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_5, [
                          _createVNode(_component_Icon, { name: "addBackgroundImage" }),
                          _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.t(`${_ctx.tBasePrefix}.uploadALocalImage`)), 1)
                        ])
                      ]),
                      _: 1
                    }, 8, ["onChange"]),
                    _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.t(`${_ctx.tBasePrefix}.uploadLocalImageTips`)), 1)
                  ]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.backgroundImgList, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "background-image-type-container",
                      key: index
                    }, [
                      _createElementVNode("div", _hoisted_8, _toDisplayString(item.title), 1),
                      _createElementVNode("div", _hoisted_9, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.list, (it) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: it.link,
                            class: _normalizeClass([
                    'list-image-content',
                    it.link === _ctx.currentLink || it.link === _ctx.imgUrl
                      ? 'active-list-image-content'
                      : ''
                  ]),
                            onClick: ($event: any) => (_ctx.handleImgSelect(it.link))
                          }, [
                            _createElementVNode("img", {
                              class: "list-image-content__img",
                              src: it.preview,
                              alt: "backgroundImage"
                            }, null, 8, _hoisted_11),
                            _createElementVNode("div", {
                              class: _normalizeClass(
                      it.link === _ctx.currentLink || it.link === _ctx.imgUrl
                        ? 'list-image-content__select-icon'
                        : ''
                    )
                            }, [
                              _createVNode(_component_Icon, {
                                name: "activeBackgroundImage",
                                fill: "transparent"
                              })
                            ], 2)
                          ], 10, _hoisted_10))
                        }), 128))
                      ])
                    ]))
                  }), 128))
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["title"])
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}